<template>
	<p
		class="text-base font-semibold text-gray-700"
		:class="{ 'mt-2 border-t border-gray-200 pt-4': !first }"
	>
		{{ label }}
	</p>
</template>

<script setup lang="ts">
	defineProps<{
		label: string;
		/** Omit the top border/spacing for the first section in a form. */
		first?: boolean;
	}>();
</script>
